(function () {
  var t = document.querySelector('[data-menu-toggle]');
  if (t) {
    var nav = document.getElementById(t.getAttribute('aria-controls'));
    t.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (nav) nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) { nav.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
    });
  }
  var form = document.querySelector('[data-cart-form]');
  if (form) {
    var err = form.querySelector('[data-consent-error]');
    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (!sub || sub.name !== 'checkout') return;
      var missing = Array.prototype.filter.call(form.querySelectorAll('[data-required-consent]'), function (c) { return !c.checked; });
      if (missing.length) {
        e.preventDefault();
        if (err) err.hidden = false;
        missing[0].focus();
      }
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-required-consent]') && err) {
        var ok = Array.prototype.every.call(form.querySelectorAll('[data-required-consent]'), function (c) { return c.checked; });
        if (ok) err.hidden = true;
      }
    });
  }
})();
